const setCookie = (key, value, domain, path = '/') => {
  if (!key || !value) return;
  document.cookie = `${key}=${value}; path=${path};${domain ? ` domain=${domain}` : ''}`;
};

export default setCookie;
